import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface SegmentedOption<T extends string> {
  value: T;
  label: ReactNode;
}

/** Segmented control (toggle Lista/Kanban, tema, densidade). */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  ariaLabel,
  className,
}: {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedOption<T>[];
  ariaLabel: string;
  className?: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={cn('inline-flex rounded bg-surface-2 p-0.5', className)}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              'inline-flex h-[calc(var(--control-h)-4px)] items-center gap-1.5 rounded-[3px] border border-transparent px-2.5 text-sm text-text-2 transition-colors duration-(--dur-fast) focus-visible:outline-none focus-visible:shadow-ring [&_svg]:size-3.5',
              active && 'border-border-strong bg-surface-1 text-text-1',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
